module.exports = __webpack_public_path__ + "static/media/Apercu-Medium.de379e19.otf";